export const authorityLv: { [key: string]: string } = {
    CLIENT: 'A',
    SUPERVISOR: 'B',
    DRILLER: 'C',
};

export function getApprovalLevelByAuthority(authority: string) {
    switch (authority) {
        case authorityLv.DRILLER:
            return '1';
        case authorityLv.SUPERVISOR:
            return '3';
        case authorityLv.CLIENT:
            return '5';
        default:
            return '1';
    }
}

export const reportStateDescription: { [key: number]: string } = {
    0: 'Draft',
    1: 'Driller Submitted',
    2: 'Supervisor Rejected',
    3: 'Supervisor Approved',
    4: 'Client Rejected',
    5: 'Client Approved',
};

export const subTables = [
    { label: 'PERSONNEL', value: 'personnel' },
    { label: 'ACTIVITIES', value: 'activities' },
    { label: 'DRILLING', value: 'drilling' },
    /*{ label: 'BREAKDOWNS', value: 'breakdowns' },*/
    { label: 'CONSUMABLES', value: 'consumables' },
    { label: 'CASING', value: 'casing' },
    { label: 'BITS AND REAMERS', value: 'bits_and_reamers' },
    { label: 'DH SURVEY', value: 'dhsurvey' },
    { label: 'GROUTING', value: 'grouting' },
    { label: 'RIG MOVES', value: 'rig_moves' },
    { label: 'RIG SERVICE', value: 'rig_service' },
    { label: 'PACKING', value: 'packing' },
    { label: 'WATER', value: 'water' },
    { label: 'FUEL', value: 'fuel' },
    { label: 'POWER PACK', value: 'power_pack' },
    { label: 'SAFETY DATA', value: 'safety_data' },
    { label: 'TRAINING', value: 'training' },
];

export const subTableOrder: { [key: string]: number } = {
    personnel: 0,
    activities: 1,
    drilling: 2,
    /*breakdowns: 3,*/
    consumables: 3,
    casing: 4,
    bits_and_reamers: 5,
    dhsurvey: 6,
    grouting: 7,
    rig_moves: 8,
    rig_service: 9,
    packing: 10,
    water: 11,
    fuel: 12,
    power_pack: 13,
    safety_data: 14,
    training: 15,
};